import { HiX } from 'react-icons/hi';
import classNames from 'classnames';
import remove from 'lodash/remove';

type CustomValueRendererInputType = {
  selected: any[];
  isMulti: boolean;
};
const CustomValueRendererInput = ({ selected, isMulti }: CustomValueRendererInputType) => {
  !isMulti && selected.length > 1 && selected.splice(0, selected.length - 1);
  return selected.length ? (
    <div className="flex justify-between items-center">
      <div className="dropdown-heading-value__content space-y-1">
        {selected
          ?.filter((item: any) => item.label)
          ?.map(({ label }: any, index: any) => {
            return (
              <div
                key={`multi-value-${index}`}
                className={classNames('flex items-center dropdown-heading-value__content--item mr-1', { 'bg-gray-200': isMulti })}
              >
                <span className="w-full">{label}</span>
                {isMulti && (
                  <button
                    className="ml-1"
                    onClick={e => {
                      e.preventDefault();
                      remove(selected, { label });
                    }}
                  >
                    <HiX size={12} />
                  </button>
                )}
              </div>
            );
          })}
      </div>
      {isMulti && (
        <button
          className="p-1 ml-2 dropdown-heading-value__hiX"
          onClick={e => {
            e.preventDefault();
            selected.splice(0, selected.length);
          }}
        >
          <HiX size={18} />
        </button>
      )}
    </div>
  ) : (
    ''
  );
};

export default CustomValueRendererInput;
